export default __webpack_public_path__ + "static/media/UNISFA_local_level_conflict_mediation_and_resolution.0764fb6b.png";